module.exports = __webpack_public_path__ + "img/bgpic.dafb2d0e.png";